import React from 'react';

const DarkModeContext = React.createContext();

export default DarkModeContext;